var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTimeZone = function SvgTimeZone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.076,
    height: 13.999,
    viewBox: "0 0 14.076 13.999",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20858",
    d: "M18148.043 9907.639a4 4 0 0 1-4.041-3.964v-5.988a4.016 4.016 0 0 1 4.041-4.047h5.912a4.135 4.135 0 0 1 4.123 4.047v5.91a4.065 4.065 0 0 1-4.047 4.042zm3.732-2.333v.779h2.18a2.509 2.509 0 0 0 2.492-2.488v-2.178h-.779a.777.777 0 1 1 0-1.555h.779v-2.178a2.461 2.461 0 0 0-2.492-2.488h-2.18v.774a.776.776 0 1 1-1.553 0v-.774h-2.18a2.457 2.457 0 0 0-2.488 2.488v2.178h.779a.777.777 0 0 1 0 1.555h-.779v2.178a2.457 2.457 0 0 0 2.488 2.488h2.18v-.779a.776.776 0 0 1 1.553 0zm-1.139-2.019-1.121-1.937a1.079 1.079 0 0 1 .205-1.227l3.063-3.062a.98.98 0 0 1 1.426 0 .992.992 0 0 1 0 1.431l-2.551 2.552.715 1.427a.906.906 0 0 1-.41 1.33.618.618 0 0 1-.41.1.98.98 0 0 1-.916-.614z",
    transform: "translate(-18144.002 -9893.64)",
    style: {
      fill: "#c4c4c4"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimeZone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timeZone.9b49ed4b.svg";
export { ForwardRef as ReactComponent };